import {
  SET_ACTIVE_VERIFICATION,
  SET_ID_FRONT,
  SET_ID_BACK,
  SET_ADDRESS_FRONT,
  SET_ADDRESS_BACK,
  SET_STUDENT_FRONT,
  SET_STUDENT_BACK,
  SET_ATTACHMENT,
  SET_CREDITCARD_FRONT
} from '../actionTypes'

const initial_state = {
  activeTab: 'passport',
  idFront: {
    file: null,
    error: null
  },
  idBack: {
    file: null,
    error: null
  },
  creditCardFront: {
    file: null,
    error: null
  },
  addressFront: {
    file: null,
    error: null
  },
  addressBack: {
    file: null,
    error: null
  },
  studentFront: {
    file: null,
    error: null
  },
  studentBack: {
    file: null,
    error: null
  },
  attachment: {
    file: null,
    error: null
  }
}

export default (state = initial_state, action) => {
  switch (action.type) {
    case SET_ACTIVE_VERIFICATION:
      return { ...state, activeTab: action.activeTab }

    case SET_ID_FRONT:
      return { ...state, idFront: action.idFront }

    case SET_ID_BACK:
      return { ...state, idBack: action.idBack }

    case SET_ADDRESS_FRONT:
      return { ...state, addressFront: action.addressFront }

    case SET_CREDITCARD_FRONT:
      return { ...state, creditCardFront: action.creditCardFront }

    case SET_ADDRESS_BACK:
      return { ...state, addressBack: action.addressBack }

    case SET_STUDENT_FRONT:
      return { ...state, studentFront: action.studentFront }

    case SET_STUDENT_BACK:
      return { ...state, studentBack: action.studentBack }

    case SET_ATTACHMENT:
      return { ...state, attachment: action.attachment }

    default:
      return { ...state }
  }
}
